import { render, staticRenderFns } from "./StoNumber.vue?vue&type=template&id=3ba55e28"
import script from "./StoNumber.vue?vue&type=script&lang=js"
export * from "./StoNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports